////////////////////////////////////////////////////////////////////////////////////////////////////
//
// The ObjectFunc class 
// @version 0.0.2.0
// @created-date 2014.04.25
// @modified-date 2015.12.06
// @author beach.li
//
// @changes 0.0.2.0 (2015.12.06)
// Support the clone object method via the cloneObject.
// Specially, it should support the native JSON class from the browser.
//
////////////////////////////////////////////////////////////////////////////////////////////////////
//--------------------------------------------------
// imported classes
//--------------------------------------------------
var ClassFunc = require("./ClassFunc");
//--------------------------------------------------
// construtor
//--------------------------------------------------
var tbs_util_GlobalFunc = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_util_GlobalFunc.prototype = {
	//--------------------------------------------------
	// static api
	//--------------------------------------------------
	/**
     * @api
     * Lock to execute the function with the given delay time.
     */
    lockExecute: function(owner, func, delayMS, args) {
        // no init status
        // owner.__locked = false;

        if (!owner.__locked) {
            // mark the locked
            owner.__locked = true;
            // execute the function
            // owner[func].apply(owner, args);
            ClassFunc.applyFunctionOnLibrary(owner, func, args);
            // pending the execute before unlocked
            owner.__toc = setTimeout(function() {
                // clear the locked flag before execution
                owner.__locked = false;
                // remove the flag because of executed
                owner.__toc = null;
            }, delayMS);
        }
    },
	/**
     * @api
     * Delay to execute the function with the given delay time.
     */
    delayExecute: function(owner, func, delayMS, args) {
        // validate the timeout controller upon the owner self
        if (owner.__toc) {
            // if existed, clear the timeout and remove the flag
            clearTimeout(owner.__toc);
            owner.__toc = null;
        }
        // delay to execute the func with args
        owner.__toc = setTimeout(function() {
            // owner[func].apply(owner, args);
            ClassFunc.applyFunctionOnLibrary(owner, func, args);
            // remove the flag because of executed
            owner.__toc = null;
        }, delayMS);
    },
    /**
     * @api
     * Clear the execution vars after lockExecute and delayExecute.
     * If there is no chance to finish the whole setTimeout function, 
     * use this method to recycle the status.
     */
    clearExecute: function(owner) {
        // clear the locked flag for the lockExecute
        if (owner.__locked) {
            owner.__locked = null;
            delete owner.__locked;
        }
        // clear the timeout and remove the toc flag
        if (owner.__toc) {
            // if existed, clear the timeout and remove the flag
            clearTimeout(owner.__toc);
            owner.__toc = null;
            delete owner.__toc;
        }
    },
    /**
     * @api
     * Start the timer to execute the function in each delay time.
     * The owner object has only one single timer 
     * with the interval controller.
     */
    startTimer: function(owner, func, delayMS, args) {
        // validate the interval controller upon the owner self
        if (owner.__ivc) {
            // if existed, clear the interval and remove the flag
            clearInterval(owner.__ivc);
            owner.__ivc = null;
        }
        // delay to execute the func with args
        owner.__ivc = setInterval(function() {
            // owner[func].apply(owner, args);
            ClassFunc.applyFunctionOnLibrary(owner, func, args);
        }, delayMS);
    },
    /**
     * @api
     * Stop the timer for the owner. 
     * The owner object has only one single timer
     * with the interval controller.
     */
    stopTimer: function(owner) {
        // clear the interval and remove the toc flag
        if (owner.__ivc) {
            // if existed, clear the interval and remove the flag
            clearInterval(owner.__ivc);
            owner.__ivc = null;
            delete owner.__ivc;
        }
    },
    /** 
     * @api
     * Set the cookie info with the name, value and exdays
     * @param name The cookie name.
     * @param value The cookie value.
     * @param exdays The expire days with the int type.
     */
    setCookie: function(name, value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        document.cookie = name + "=" + escape(value) + ((exdays == null) ? "" : ";expires=" + exdate.toGMTString());
    },
    /**
     * @api
     * Get the cookie info via the cookie name.
     * @param name The cookie name.
     * @return The cookie value.
     */
    getCookie: function(name) {
        var cookie = document.cookie;
        if (cookie && cookie.length > 0) {
            var cookieArr = cookie.split("; ");
            // console.log("cookieArr", cookieArr);
            for (var i = 0; i < cookieArr.length; i++) {
                var cookieItem = cookieArr[i];
                var nameIndex = cookieItem.indexOf(name + "=");
                if (nameIndex == 0) {
                    var eleArr = cookieItem.split("=");
                    if (eleArr.length == 2) {
                        return unescape(eleArr[1]);
                    }
                }
            }
        }
        return null;
    },
	/**
	 * @api
	 * Get the GUID with xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx.
	 * Define the simple type with the xxxx-xxxx-xxxx-xxxx format.
	 */
	guid: function(type) {
		var S4 = function() {
			return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
		}
		if (type === 1) {
			return (S4()+"-"+S4()+"-"+S4()+"-"+S4());
		}
        else if (type === 32) {
            return (S4() + S4() + S4() + S4() 
                + S4() + S4() + S4() + S4());
        }
        else if (type === 64) {
            return (S4() + S4() + S4() + S4() 
                + S4() + S4() + S4() + S4() 
                + S4() + S4() + S4() + S4() 
                + S4() + S4() + S4() + S4());
        }
		else {
			return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
		}
	}
};

/**
 * The static implementation approach
 * @return The static method.
 */
var instance;
if (!instance) {
	instance = new tbs_util_GlobalFunc;
}

module.exports = instance;